module.exports = __webpack_public_path__ + "img/gallery7.175e14c.jpg";